import { useTranslation } from 'react-i18next'
import { PlaceIcon24 } from '@repo/ui/icons'
import useIsOlderThan from '@/features/befehlsnachrichten/hooks/useIsOlderThan'
import { LoadingIndicator } from '@repo/ui'

export interface BfnStatusInfoStandorteingabeDurchFdlProps {
  standortSentDate: Date | null | undefined
  'data-testid': string
}

export default function BfnStatusInfoStandorteingabeDurchFdl({
  standortSentDate,
  'data-testid': testId
}: Readonly<BfnStatusInfoStandorteingabeDurchFdlProps>) {
  const { t } = useTranslation('bfnDetails')
  const isStandortSentTimeWarning = useIsOlderThan(
    standortSentDate ?? null,
    3 * 60
  )

  return (
    <div className="flex flex-col items-center text-center gap-1 mb-2">
      <div>
        <PlaceIcon24 className="shrink-0" data-testid={`${testId}-icon`} />
      </div>
      {!isStandortSentTimeWarning && (
        <>
          <p data-testid={`${testId}-success-text`}>
            {t(
              'status_info.standorteingabe_durch_fdl_erforderlich.success_text'
            )}
          </p>
          <p data-testid={`${testId}-instruction-text`}>
            {t(
              'status_info.standorteingabe_durch_fdl_erforderlich.instruction_text'
            )}
          </p>
        </>
      )}
      {isStandortSentTimeWarning && (
        <>
          <p data-testid={`${testId}-warning-text`}>
            {t(
              'status_info.standorteingabe_durch_fdl_erforderlich.time_warning.warning_text'
            )}
          </p>
          <p className="font-bold" data-testid={`${testId}-instruction-text`}>
            {t(
              'status_info.standorteingabe_durch_fdl_erforderlich.time_warning.instruction_text'
            )}
          </p>
        </>
      )}
      <LoadingIndicator className="mt-0.5" data-testid={`${testId}-loading`} />
    </div>
  )
}
